import { create } from "zustand";

export type StepsModel<Steps extends readonly string[]> = {
  step: Steps[number];
  allSteps: Steps;
  isFirstStep: boolean;
  isLastStep: boolean;
  setStep: (step: Steps[number]) => void;
  nextStep: () => void;
  previousStep: () => void;
};

export function createStepsStore<Items extends readonly string[]>(steps: Items) {
  if (!steps.length) {
    throw new Error("Steps array must not be empty");
  }

  type StateInternal = StepsModel<Items> & { _stepIndex: number };

  return create<StepsModel<Items>>((set) => ({
    _stepIndex: 0,
    step: steps[0],
    allSteps: steps,
    isFirstStep: true,
    isLastStep: steps.length === 1,
    nextStep: () =>
      set((state: StateInternal) => {
        if (state._stepIndex === steps.length) {
          return state;
        }
        const nextIndex = state._stepIndex + 1;
        return {
          _stepIndex: nextIndex,
          step: steps[nextIndex],
          isFirstStep: false,
          isLastStep: nextIndex === steps.length - 1,
        };
      }),
    previousStep: () =>
      set((state: StateInternal) => {
        if (state._stepIndex === 0) {
          return state;
        }
        const nextIndex = state._stepIndex - 1;
        return {
          _stepIndex: nextIndex,
          step: steps[nextIndex],
          isFirstStep: nextIndex === 0,
          isLastStep: false,
        };
      }),
    setStep: (step) => {
      set(() => {
        const nextIndex = steps.indexOf(step);
        return {
          _stepIndex: nextIndex,
          step,
          isFirstStep: nextIndex === 0,
          isLastStep: nextIndex === steps.length - 1,
        };
      });
    },
  }));
}
